import api from "../../../store/AuthHeader";

const getAllMemberActivities = () => {
    return api.get("/MemberWorkActivity/GetAllDefaultWorkActivitiesByBMAMember");
};

const getWorkActivityCategories = () => {
    return api.get("/MemberWorkActivity/getWorkActivityCategories");
};

const getWorkActivitySubCategories = (id: any) => {
    return api.get("/MemberWorkActivity/getWorkActivitySubCategories/"+id);
};

const removeWorkActivitySubCategories = (id: any) => {
    return api.delete(`/MemberWorkActivity/${id}`);
};

const saveCategoryWorkActivities = (payload: any) => {
    return api.post(`/MemberWorkActivity/SaveJobCategoryWorkActivity`, payload);
};

const saveSubCategoryWorkActivities = (payload: any) => {
    return api.post(`/MemberWorkActivity/SaveJobSubCategoryWorkActivity`, payload);
};

const removeUserDefinedWorkActivityCategory = (id: any) => {
    return api.delete(`/MemberWorkActivity/DeleteUserDefinedWorkActivityCategory/${id}`);
};

export default {
    getAllMemberActivities,
    getWorkActivityCategories,
    getWorkActivitySubCategories,
    removeWorkActivitySubCategories,
    saveCategoryWorkActivities,
    saveSubCategoryWorkActivities,
    removeUserDefinedWorkActivityCategory
};